import { ReactNode, MouseEvent } from "react";
import { Button as GreenButton } from "@sebgroup/green-react";
import Spinner from "../Loaders/Spinner";

interface ButtonProps {
  children?: ReactNode;
  className?: string;
  text?: string | number;
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "secondary" | "ghost" | "tertiary" | "close";
  onClick: ((event: MouseEvent) => void) | (() => void);
  "aria-expanded"?: boolean;
  "aria-controls"?: string;
  "aria-label"?: string;
  size?: "small" | "large" | undefined;
  "data-testid"?: string;
  loading?: boolean;
}

const Button = (props: ButtonProps) => {
  const handleClick = (event: MouseEvent) => {
    if (!props.loading) {
      props.onClick(event);
    }
  };

  return (
    <GreenButton
      className={props.className}
      variant={props.variant}
      type={props.type}
      size={props.size}
      onClick={handleClick}
      aria-controls={props["aria-controls"]}
      aria-expanded={props["aria-expanded"]}
      aria-label={props["aria-label"]}
      data-testid={props["data-testid"]}
      aria-busy={props.loading}
    >
      {props.text}
      {props.loading ? <Spinner color="inherit" /> : props.children}
    </GreenButton>
  );
};

export default Button;
